import { createContext } from "react";

const FirestoreContext = createContext(null);

export default FirestoreContext;
